import { Controller } from "@hotwired/stimulus"

// Drag dots along the hill. The x axis is the only degree of freedom: 0-100
// maps to the SVG width, the y follows the bell curve. On release, PATCH the
// new position; on failure the dot snaps back.
export default class extends Controller {
  static values = { url: String }
  static targets = ["dot"]

  connect() {
    this.dragging = null
    this.onMove = this.move.bind(this)
    this.onUp = this.up.bind(this)
  }

  start(event) {
    const group = event.currentTarget
    this.dragging = group
    this.startPosition = parseInt(group.dataset.position, 10)
    event.preventDefault()
    window.addEventListener("pointermove", this.onMove)
    window.addEventListener("pointerup", this.onUp)
  }

  move(event) {
    if (!this.dragging) return
    const svg = this.element.querySelector("svg")
    const rect = svg.getBoundingClientRect()
    const fraction = (event.clientX - rect.left) / rect.width
    const position = Math.max(0, Math.min(100, Math.round(((fraction * 880) - 40) / 8)))
    this.place(this.dragging, position)
  }

  async up() {
    if (!this.dragging) return
    const group = this.dragging
    this.dragging = null
    window.removeEventListener("pointermove", this.onMove)
    window.removeEventListener("pointerup", this.onUp)

    const position = parseInt(group.dataset.position, 10)
    if (position === this.startPosition) return

    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: { "Content-Type": "application/json", "X-CSRF-Token": csrfToken, "Accept": "application/json" },
        body: JSON.stringify({
          hillable_type: group.dataset.hillableType,
          id: group.dataset.hillableId,
          position: position
        })
      })
      if (!response.ok) throw new Error("update failed")
    } catch {
      this.place(group, this.startPosition)
    }
  }

  place(group, position) {
    const x = 40 + position * 8
    const y = 180 - 140 * Math.exp(-((position - 50) ** 2) / 650)
    group.dataset.position = position
    group.setAttribute("transform", `translate(${x}, ${y})`)
  }
}
